<template>
  <v-dialog v-model="dialog" persistent width="950">
    <modificarIncrementoDetalle />
    <v-card class="p-0">
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{
            form.id
              ? "Editar Incremento Salarial por cargo"
              : "Crear Incremento Salarial por pago"
          }} 
       
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%">
            <v-layout wrap row>
              <v-flex xs12 md6>
                <v-text-field
                  label="Fecha de ejecución"
                  v-model="form.fecha_ejecucion"
                  :rules="$validate(['required'])"
                  @input="obtenerGestion()"
               
                  required
                  type="date"
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Gestión"
                  v-model="form.gestion"
                  :rules="$validate(['required'])"
                  required
				          disabled
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="lista_cargos"
                  item-text="cargo"
                  item-value="id_cargo"
                  label="Seleccione el cargo"
                  @input="cargarHaber()"
                  v-model="form.id_cargo"
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Porcentaje de incremento (%)"
                  v-model="form.incremento_porcentaje"
                  :rules="$validate(['required'])"
                  required
                  @input="cargarHaber()"
                  type="number"
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="form.id_cargo"
                  label="Haber básico actual"
                  v-model="form.haber_actual"
                  :rules="$validate(['required'])"
                  required
                  type="number"
                  outline
                  success
                  clearable
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="form.id_cargo && form.haber_actual"
                  label="Haber básico incrementado"
                  v-model="form.haber_incrementado"
                  :rules="$validate(['required'])"
                  required
                  type="number"
                  outline
                  success
                  clearable
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-spacer></v-spacer>
                <v-btn
                  color="rgb(147,13,242)"
                  block
                  dark
                  @click="adicionarDetalle()"
                  :disabled="
                    !form.haber_actual ||
                    !form.haber_incrementado ||
                    !form.incremento_porcentaje ||
                    !form.id_cargo
                  "
                >
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    <v-form>
        <v-card-text>
          <v-container>
            <h3><strong>Listado de incrementos salariales</strong></h3>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="incremento_salarial_detalles"
                  class="elevation-1"
                  :headers="headers_detalles"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.cargo }}
                    </td>
                    <td class="text-xs-center">{{ props.item.porcentaje }}</td>
                    <td class="text-xs-center">
                      {{ props.item.haber_basico_actual }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.haber_basico_incrementado }}
                    </td>
                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar registro"
                        @click="
                          eliminarIncremento(props.item)
                        "
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <v-btn
                        color="warning"
                        icon
                        title="Modificar registro"
                        @click="modificarIncrementoDetalle(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout class="pa-2"> </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> CERRAR
          </v-btn>
          <!-- <v-btn
            color="primary"
            type="submit"
            @click="save"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import modificarIncrementoDetalle from "../dialogs/ModificarIncrementoDetalle.vue";

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      lista_cargos: [],
      incremento_salarial_detalles: [],
      id_incremento_salarial: null,

      headers_detalles: [
        { text: "Cargo", value: "cargo", align: "center" },
        { text: "Porcentage", value: "porcentage", align: "center" },
        {
          text: "Haber básico actual",
          value: "haber_basico_actual",
          align: "center",
        },
        {
          text: "Haber básico incrementado",
          value: "haber_basico_incrementado",
          align: "center",
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
    };
  },
  mounted() {
    this.$bus.$on(
      "openDialogCrearActualizarIncrementoSalarial",
      async (item) => {
        this.form = item;
        await this.cargarCargos();
        if (this.form.id_incremento) {
          this.id_incremento_salarial = this.form.id_incremento;

          await this.cargarIncrementoSalarialDetalle(this.form.id_incremento);
		 
        }
        this.dialog = true;
        this.$bus.$on("closeDialogIncrementoDetalle", async () => {
            this.id_incremento_salarial = this.form.id_incremento;

            await this.cargarIncrementoSalarialDetalle(this.form.id_incremento);

        });
      }
    );
  },
  methods: {
    close() {
      this.form = {};
      this.loading = false;
      this.incremento_salarial_detalles = [];
      this.valid = false;
      this.$bus.$emit("closeDialogIncrementoSalarial");
      this.dialog = false;
    },
    async eliminarIncremento(dato) {
      try {
		this.$confirm('Desea eliminar el registro?', async() => {
      let id_incremento_salarial=dato.id_incremento_salarial
			let usuario=this.$storage.get("user");
			let respuesta = await this.$service.graphql({
              query: `
                          query{
                            runQuery(consulta:"select movilidad.fn_elimina_incremento_salarial_detalle(${parseInt(dato.id_incremento_salarial_detalle)},${dato.id_cargo},${usuario.id})"){
                            respuesta
                            }
                          }
                        `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_elimina_incremento_salarial_detalle;
            let resps = respuesta.split("|");
			if (resps[0]=="1") {
				this.$message.info("Registro eliminado exitosamente");
				await this.cargarIncrementoSalarialDetalle(id_incremento_salarial);
			}
		});
      } catch (error) {
        console.log(error);
      }
    },
    async cargarCargos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
				query {
					runQuery(consulta:"select * from movilidad.v_item_cargo"){
						respuesta
					}
					}
				`,
        });
        this.lista_cargos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarIncrementoSalarialDetalle(id) {
      try {
        this.incremento_salarial_detalles = [];
        if (id) {
          let respuesta = await this.$service.graphql({
          query: `
				query {
					runQuery(consulta:"select * from movilidad.v_incremento_salarial_detalle vis where vis.id_incremento_salarial=${parseInt(
            id
          )} and vis.id_estado_incremento_salarial_detalle<>2"){
						respuesta
					}
					}
				`,
        });
        this.incremento_salarial_detalles = respuesta.runQuery.respuesta;
        }

      } catch (error) {
        console.log(error);
      }
    },
    async obtenerGestion() {
      try {
		console.log("-+++++",this.form.fecha_ejecucion.length)
        if (
          this.form.fecha_ejecucion &&
          this.form.fecha_ejecucion.length == 10
        ) {
			let año = parseInt(this.form.fecha_ejecucion.substring(0, 4));
			console.log(año,"-9-9-9-9--")
			this.form.gestion=año
			
        }
		if (this.form.fecha_ejecucion.length > 10
        ) {
			this.$message.info("Fecha no valida");
          return;}
      } catch (error) {
        console.log(error);
      }
    },
     modificarIncrementoDetalle(dato) {
     dato.fecha_ejecucion=this.form.fecha_ejecucion;
	 dato.gestion=this.form.gestion;
      this.$bus.$emit("openDialogActualizarIncrementoSalarial", dato);
    },
    async adicionarDetalle() {
      try {
        if (this.$refs.form.validate()) {
          let usuario = this.$storage.get("user");
          let correcto;

          if (this.incremento_salarial_detalles.length < 1) {
            let respuesta = await this.$service.graphql({
              query: `
                          query{
                            runQuery(consulta:"select movilidad.fn_registra_incremento_salarial(${parseInt(
                              this.form.gestion
                            )},'${this.form.fecha_ejecucion}',${usuario.id})"){
                            respuesta
                            }
                          }
                        `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_incremento_salarial;
            let resps = respuesta.split("|");
            correcto = resps[0];
            this.id_incremento_salarial = resps[1];

            if (correcto != "1") {
              this.$message.warnings(resps[1]);
              return;
            }
          } else {
                   //modificando la cabecera:
				   let resps1
				   let respuesta2 = await this.$service.graphql({
                      query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_actualiza_incremento_salarial_cabecera(${parseInt(this.id_incremento_salarial)},${parseInt(this.form.gestion)},'${this.form.fecha_ejecucion}',${usuario.id})"){
                              respuesta
                              }
                            }
                          `
                    });
                    respuesta2 =respuesta2.runQuery.respuesta[0].fn_actualiza_incremento_salarial_cabecera
                     resps1 = respuesta2.split("|");

					 if (resps1[0] != "1") {
              this.$message.warnings(resps1[1]);
              return;
            }
          }
          //almacenando los detalles
          let rpta = await this.$service.graphql({
            query: `
                          query{
                            runQuery(consulta:"select movilidad.fn_registra_incremento_salarial_detalle(${parseInt(
                              this.id_incremento_salarial
                            )},${parseInt(this.form.id_cargo)},'${
              this.form.haber_incrementado
            }','${this.form.incremento_porcentaje}',${usuario.id})"){
                            respuesta
                            }
                          }
                        `,
          });
          rpta =
            rpta.runQuery.respuesta[0].fn_registra_incremento_salarial_detalle;
          let resps = rpta.split("|");
          if (resps[0] == "1") {
            this.$confirm("Registro exitoso");
            await this.cargarIncrementoSalarialDetalle(
              this.id_incremento_salarial
            );

            this.form.id_cargo = null;
            this.form.incremento_porcentaje = null;
            this.form.haber_actual = null;
            this.form.haber_incrementado = null;
          } else {
            this.$confirm(resps[1]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarHaber() {
      try {
        let nuevo_haber;
       // let haber_antiguo_no_formateado=parseFloat(this.form.haber_actual)
        if (this.form.id_cargo) {
          const haber_actual = this.lista_cargos.find(
            (fruta) => fruta.id_cargo == parseInt(this.form.id_cargo)
          ).sueldo;
          this.form.haber_actual = parseFloat(
            haber_actual.replace(/\./g, "").replace(/\,/g, ".")
          );
        }
        if (this.form.haber_actual && this.form.incremento_porcentaje) {
          nuevo_haber =
            (this.form.incremento_porcentaje / 100) * this.form.haber_actual +
            this.form.haber_actual;
          this.form.haber_incrementado = nuevo_haber;
         // let nuevo_haber_sin_formato=(haber_antiguo_no_formateado/100)*
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    modificarIncrementoDetalle,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/incremento_salarial/dialogs/CrearActualizarIncrementoSalarial.vue